import Auth0 from 'auth0-js'
import { Tenant } from '@/types'
import { parseRedirectUri } from './parse-redirect-uri'
import { nrRedirectToProduct } from '../newrelic'

/**
  Redirects the user to the provided uri assuming that the uri is within the
  Auth0 tenant's authorised callbacks

  On error, the user will be redirected to an Auth0 error page
* */
export const authorizeRedirectUri = async (tenant: Tenant, redirectUri: string, temporaryMfaSetup: boolean = false, purpose: string = undefined) => {
  if (!tenant) {
    throw new Error('TenantRequired')
  }

  if (!redirectUri) {
    throw new Error('RedirectURIRequired')
  }

  const webAuth = new Auth0.WebAuth({
    domain: tenant.loginDomain,
    clientID: tenant.loginClientId,
  })

  nrRedirectToProduct()

  webAuth.authorize({
    prompt: 'none',
    responseType: 'code',
    redirectUri: parseRedirectUri(redirectUri, tenant.aliasCode || tenant.code, undefined, temporaryMfaSetup, purpose),
  })
}
